import React,{useState, useEffect}  from 'react';
import Sides from '../Bars/Jssidebar';
import Button from 'react-bootstrap/Button'


import { Helmet } from "react-helmet";
function Cscontrolstruct(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
      <Sides/>
        
        <Helmet>
 
 <title>what is DOM in javascript Free tutorial For Beginners</title>
 <meta name="description" content="what is dom in javascript tutorial for beginners Dom tutorial in Javascript is a program dom method and dom function provides Multiple Programming Examples for Beginners" />
 <meta name="keywords" content="codeexampler,tutorial for begineers,what is dom in javascript,what is javascript dom,javascript dom manipulation,javascript dom methods,javascript dom events,javascript dom element" />
 <link rel="canonical" href="https://www.codeexampler.com/javascript-dom-method" />
 </Helmet>

 <div className='lg:pl-56'>
    <h1 className="m-4 mh1">What is dom in javascript?</h1>
    <div className="first">
        <a href="/javascript-user-define-function">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/javascript-history">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>

        <h2 className="mt-4 mh2">Dom Method in Javascript</h2>




<h2 className="headings">Hello World program in Javascript example</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        {"\n"}
        <span className="qwerty-3">&#60;/</span>
<span className="qwerty-6">head</span>
          <span className="qwerty-3">&#62; </span>
           
  {"\n"}
        <span className="qwerty-3">&#60;/</span>
<span className="qwerty-7">title</span>
          <span className="qwerty-3">&#62; </span>
           
  <span className="qwerty-10">My First Dom </span>
        <span className="qwerty-3">&#60;/</span>
<span className="qwerty-7">title</span>
          <span className="qwerty-3">&#62; </span>
           
  {"\n"}
        <span className="qwerty-3">&#60;</span>
<span className="qwerty">p </span>
<span className="qwerty-3">id</span>
<span className="qwerty">=</span> 
<span className="qwerty-3">"</span> 
        <span className="qwerty-8">first</span> 
        <span className="qwerty-3">"</span> 
          <span className="qwerty-3">&#62; </span>
           
        <span className="qwerty-3">&#60;/</span>
<span className="qwerty">p</span>
          <span className="qwerty-3">&#62; </span>
           
        {"\n"}
        <span className="qwerty-3">&#60;</span>
<span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
           
  {"\n"}
        {"\n"}
        <span className="qwerty-2">&nbsp;&nbsp;document</span>
      <span className="qwerty">.</span>
      <span className="qwerty-2">getElementById</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-3">"</span> 
        <span className="qwerty-4">first</span> 
        <span className="qwerty-3">"</span> 
      <span className="qwerty-1">)</span>
      <span className="qwerty">.</span>
      <span className="qwerty-2">innerHTML</span>
      <span className="qwerty">=</span>
      <span className="qwerty-3">"</span> 
        <span className="qwerty-4">My Dom!</span> 
        <span className="qwerty-3">"</span> 
      {"\n"} {"\n"}
<span className="qwerty-3">&#60;/</span>
<span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
            {"\n"}
    
<span className="qwerty-3">&#60;/</span>
<span className="qwerty-6">head</span>
          <span className="qwerty-3">&#62; </span>
            {"\n"}
     </code>
      </pre>        
    </div>
    
    
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;My Dom! </span>          
          {"\n"}
            </code>{"   "}
            </pre>
      </div>
    </div>

<h2 className="mt-4 mh2">Dom Element in Javascript</h2>




<h2 className="headings">Hello World program in Javascript example</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        {"\n"}
        <span className="qwerty-3">&#60;/</span>
<span className="qwerty-6">head</span>
          <span className="qwerty-3">&#62; </span>
           
  {"\n"}
        <span className="qwerty-3">&#60;/</span>
<span className="qwerty-7">title</span>
          <span className="qwerty-3">&#62; </span>
           
  <span className="qwerty-10">My Dom Element Method </span>
        <span className="qwerty-3">&#60;/</span>
<span className="qwerty-7">title</span>
          <span className="qwerty-3">&#62; </span>
           
  {"\n"}
        <span className="qwerty-3">&#60;</span>
<span className="qwerty">p </span>
<span className="qwerty-3">id</span>
<span className="qwerty">=</span> 
<span className="qwerty-3">"</span> 
        <span className="qwerty-8">first</span> 
        <span className="qwerty-3">"</span> 
          <span className="qwerty-3">&#62; </span>
          <span className="qwerty-4">Hello Codeexampler</span> 
        <span className="qwerty-3">&#60;/</span>
<span className="qwerty">p</span>
          <span className="qwerty-3">&#62; </span>
           
        {"\n"}
        <span className="qwerty-3">&#60;</span>
<span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
           
  {"\n"}
        <span className="qwerty-3">&nbsp;&nbsp;var </span>
        <span className="qwerty-4">a</span>
        <span className="qwerty">=</span>
        <span className="qwerty-2">document</span>
      <span className="qwerty">.</span>
      <span className="qwerty-2">getElementById</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-3">"</span> 
        <span className="qwerty-4">first</span> 
        <span className="qwerty-3">"</span> 
      <span className="qwerty-1">)</span>
        {"\n"}
        <span className="qwerty-2">&nbsp;&nbsp;document</span>
      <span className="qwerty">.</span>
      <span className="qwerty-2">getElementById</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-3">"</span> 
        <span className="qwerty-4">first</span> 
        <span className="qwerty-3">"</span> 
      <span className="qwerty-1">)</span>
      <span className="qwerty">.</span>
      <span className="qwerty-2">innerHTML</span>
      <span className="qwerty">=</span>
      <span className="qwerty-3">"</span> 
        <span className="qwerty-4">programming website is :</span>
      <span className="qwerty">+</span>
      <span className="qwerty-4">a</span>
      <span className="qwerty">.</span>
      <span className="qwerty-2">innerHTML;</span>
      {"\n"} {"\n"}
<span className="qwerty-3">&#60;/</span>
<span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
            {"\n"}
    
<span className="qwerty-3">&#60;/</span>
<span className="qwerty-6">head</span>
          <span className="qwerty-3">&#62; </span>
            {"\n"}
    </code>
      </pre>        
    </div>
    
    
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;programming website is : Hello Codeexampler </span>          
          {"\n"}
            </code>{"   "}
            </pre>
      </div>
    </div>


  <h1 className="mt-5">  </h1>
  <div className="back">
        <a href="/javascript-user-define-function">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/javascript-history">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Cscontrolstruct;